"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UseCaseExecutor_1 = require("./UseCaseExecutor");
var FunctionalUseCaseContext_1 = require("./FunctionalUseCaseContext");
var FunctionalUseCase_1 = require("./FunctionalUseCase");
var UseCase_1 = require("./UseCase");
var assert_1 = require("./util/assert");
function createUseCaseExecutor(useCase, dispatcher) {
    // instance of UseCase
    if (UseCase_1.isUseCase(useCase)) {
        return new UseCaseExecutor_1.UseCaseExecutorImpl({
            useCase: useCase,
            parent: UseCase_1.isUseCase(dispatcher) ? dispatcher : null
        });
    }
    else if (FunctionalUseCaseContext_1.isUseCaseFunction(useCase)) {
        // When pass UseCase constructor itself, throw assertion error
        assert_1.assertOK(Object.getPrototypeOf && Object.getPrototypeOf(useCase) !== UseCase_1.UseCase, "Context#useCase argument should be instance of UseCase.\nThe argument is UseCase constructor itself: " + useCase);
        // function to be FunctionalUseCase
        var functionalUseCase = new FunctionalUseCase_1.FunctionalUseCase(useCase);
        return new UseCaseExecutor_1.UseCaseExecutorImpl({
            useCase: functionalUseCase,
            parent: UseCase_1.isUseCase(dispatcher) ? dispatcher : null
        });
    }
    throw new Error("Context#useCase argument should be UseCase: " + useCase);
}
exports.createUseCaseExecutor = createUseCaseExecutor;
//# sourceMappingURL=UseCaseExecutorFactory.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/UseCaseExecutorFactory.js
// module id = 194
// module chunks = 0